import { render, staticRenderFns } from "./file-info-details.vue?vue&type=template&id=c7ee6754&scoped=true"
import script from "./file-info-details.vue?vue&type=script&lang=ts"
export * from "./file-info-details.vue?vue&type=script&lang=ts"
import style0 from "./file-info-details.vue?vue&type=style&index=0&id=c7ee6754&prod&lang=less&scoped=true"
import style1 from "./file-info-details.vue?vue&type=style&index=1&id=c7ee6754&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ee6754",
  null
  
)

export default component.exports